module.exports = __webpack_public_path__ + "d7e19e1f3b9884436a93540347e0507b.svg";